import { pageClickHandler } from '../helpers/router-helper';

export const NavigationItem = ({
  scope, siteMap, shouldNavigate, targetPage,
}) => {
  if (shouldNavigate) {
    pageClickHandler(siteMap, scope, targetPage);
  }

  return null;
};

NavigationItem.defaultProps = {
  targetPage: 'settings',
};
